import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { memo } from "react";
export const FaIcon = memo((props) => {
    const { icon, overlayIcon, className = "", ...rest } = props;
    if (overlayIcon) {
        return (_jsxs("span", { className: "fa-layers fa-fw", children: [_jsx(FontAwesomeIcon, { ...rest, className: className, icon: icon }), _jsx(FontAwesomeIcon, { icon: overlayIcon, transform: "shrink-6" })] }));
    }
    else {
        return _jsx(FontAwesomeIcon, { ...rest, className: className, icon: icon });
    }
});
FaIcon.displayName = "FaIcon";
